import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientStudentGroupsManagement = async (
  { rootGetters },
  { clientSubdomain, queryParam }
) => {
  const axios = rootGetters['app/stbAxios'];

  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getClientStudentGroupsManagement(clientSubdomain, queryParam);
  return response;
};
